export default __webpack_public_path__ + "static/media/flag-pt.e40eaada.svg";